import React, { useState, useContext, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { ModalBody, Container } from './styles';
import { AppStoreContext } from '../../context/appStoreContext';
import { useSessionContext } from '../../context/sessionContext';
import { clearUserData } from '../../utils/services/networkService';
import Session from 'supertokens-web-js/recipe/session';
import { withTranslation } from 'react-i18next';
import i18n from '../../i18n';
import { LOGOUT_MODAL } from './translationValues';

const NAMESPACES = ['LOGOUT_MODAL'];

const LogOutModal = props => {
  const { visible, OnCancel, t } = props;
  const [loggingOff, setLoggingOff] = useState(false);
  const { setUserPermission, setLoginVisible, setOnboardingStatus, ssoAuthClient: authClient } = useContext(AppStoreContext);

  let history = useHistory();

  const LogOutHandler = async () => {
    setLoggingOff(true);
    if (authClient) {
      await authClient.reset();
    }
    await Session.signOut();
    setLoggingOff(false);
    clearUserData(false);
    setUserPermission({});
    setLoginVisible(true)
    setOnboardingStatus(false)
    OnCancel();
    history.push('/');

    //Setting the application language to browser language on sign out
    i18n.changeLanguage(navigator.language || navigator.userLanguage);
    localStorage.removeItem('sso_signIn');
  };

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      LogOutHandler();
    }
  };

  return (
    <Container onKeyDown={e => e.stopPropagation()} onKeyPress={handleKeyPress}>
      <Modal
        title={t(LOGOUT_MODAL.LOGOUT_TITLE.key, LOGOUT_MODAL.LOGOUT_TITLE.value)}
        centered
        maskClosable={false}
        visible={visible}
        width="625px"
        onCancel={OnCancel}
        footer={[
          <Button key="back" onClick={OnCancel}>
            {t(LOGOUT_MODAL.CANCEL_LOGOUT_BUTTON.key, LOGOUT_MODAL.CANCEL_LOGOUT_BUTTON.value)}
          </Button>,
          <Button key="submit" type="primary" loading={loggingOff} onClick={LogOutHandler}>
            {loggingOff
              ? t(LOGOUT_MODAL.LOGGING_OFF_BUTTON.key, LOGOUT_MODAL.LOGGING_OFF_BUTTON.value)
              : t(LOGOUT_MODAL.LOGOUT_BUTTON.key, LOGOUT_MODAL.LOGOUT_BUTTON.value)}
          </Button>,
        ]}
        className="warning-modal"
      >
        <ModalBody>
          <div className="warning-text">
            <span>
              {t(LOGOUT_MODAL.CONFIRMATION_TEXT.key, LOGOUT_MODAL.CONFIRMATION_TEXT.value)}
            </span>
          </div>
        </ModalBody>
      </Modal>
    </Container>
  );
};
export default withTranslation(NAMESPACES)(LogOutModal);
